/**
 * Get query params and returns key-values based dictionary.
 * @returns Record<string, string>
 */
const getQueryParams = (): Record<string, string> => {
  if (typeof window === 'undefined') return {};

  const queryParams = new URLSearchParams(window.location.search);

  const result: Record<string, string> = {};

  queryParams.forEach((value, key) => (result[key] = value));

  return result;
};

export default getQueryParams;
